export default __webpack_public_path__ + "static/media/iPadSS9.9d43fc89.png";